import type { JSX, ReactNode } from 'react';

import { cx } from '@emotion/css';
import { Col, Row, Space } from 'antd';
import { Color } from 'src/styles';

import { ConfirmPanelType } from '../../../models/confirm-panel.enum';
import { MTypography } from '../../MTypography/MTypography';

import * as Styles from './styles';

interface ConfirmPanelProps {
  title: string;
  description: ReactNode | string;
  iconSource: ReactNode;
  type: ConfirmPanelType;
}

const ConfirmPanel = ({ title, description, iconSource, type }: ConfirmPanelProps): JSX.Element => {
  return (
    <Row justify={'center'}>
      <Col>
        <Space direction='vertical'>
          <Row justify={'center'}>
            <Col
              className={cx(
                Styles.logoCircle,
                type === ConfirmPanelType.ERROR ? Styles.errorLight : Styles.successLight,
              )}>
              <span
                className={cx(Styles.logo, type === ConfirmPanelType.ERROR ? Styles.errorColor : Styles.successColor)}>
                {iconSource}
              </span>
            </Col>
          </Row>
          <MTypography
            variant='subtitle1'
            weight='bold'
            align='center'
            color={type === ConfirmPanelType.ERROR ? Color.Red6 : Color.Green6}>
            {title}
          </MTypography>
          <MTypography variant='body1' align='center' color={Color.Gray7}>
            {description}
          </MTypography>
        </Space>
      </Col>
    </Row>
  );
};

export default ConfirmPanel;
